import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, message, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, CalendarOutlined } from '@ant-design/icons';
import { getInternalReportSchedules, deleteInternalReportSchedule } from '../../services/internalReportingService';
import ScheduleFormModal from './ScheduleFormModal';

const SchedulesTab = () => {
  const [loading, setLoading] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);

  const fetchSchedules = async () => {
    setLoading(true);
    try {
      const res = await getInternalReportSchedules();
      if (res?.status) {
        setSchedules(res.data);
      }
    } catch (err) {
      console.error('Failed to fetch schedules:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchedules();
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await deleteInternalReportSchedule(id);
      if (res?.status) {
        message.success('Schedule deleted');
        fetchSchedules();
      }
    } catch (err) {
      message.error('Failed to delete schedule');
    }
  };

  const columns = [
    {
      title: 'Report Name',
      dataIndex: 'reportName',
      key: 'reportName',
    },
    {
      title: 'Type',
      dataIndex: 'reportType',
      key: 'reportType',
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency',
      render: (freq) => (
        <Tag color="cyan">
          <CalendarOutlined /> {freq}
        </Tag>
      ),
    },
    {
      title: 'Next Run',
      dataIndex: 'nextRun',
      key: 'nextRun',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Active' ? 'success' : 'default'}>{status}</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => {
              setEditingSchedule(record);
              setModalVisible(true);
            }}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this schedule?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="text" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="schedules-tab">
      <div style={{ marginBottom: '16px', textAlign: 'right' }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setEditingSchedule(null);
            setModalVisible(true);
          }}
        >
          Create Schedule
        </Button>
      </div>

      <Table
        loading={loading}
        columns={columns}
        dataSource={schedules}
        rowKey="id"
        className="reg-table"
      />

      <ScheduleFormModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSuccess={() => {
          setModalVisible(false);
          fetchSchedules();
        }}
        schedule={editingSchedule}
      />
    </div>
  );
};

export default SchedulesTab;
